import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const KaunHai = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - KAUN HAI?</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - KAUN HAI?</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Chorus: Gaush &amp; Flowbo]<br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai? (Kaun hai?)<br/>
                Todenge jagah pe tere ko chodenge kaise new Bombay se (Let's go!)<br/>
                <br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai?<br/>
                Todenge jagah pe tere ko chodenge kaise hum Bombay se<br/>
                <br/>
                [Verse 1: Gaush]<br/>
                Dedu tel ko aag tere ko raakh<br/>
                Baat kehdu main saaf<br/>
                Bhale main haa aaj pehnu nakaab<br/>
                Kehne ko laakh baat kehke faraar<br/>
                Mere jaisa khaakh<br/>
                Tujhe aas paas kabhi mil&#1077;ga na<br/>
                Inhe tabah kar awaam aaj mere p&#1077; naaz kare<br/>
                Sick likhte itne bol kitne bars bhare<br/>
                Din ginle inke kyun milenge laash gadhe<br/>
                Phir pighle dil bin reeti reewaj par main<br/>
                Kyun ki dekh, success se hoti na doori sehen<br/>
                Aaine ke saamne tha yuhi main<br/>
                Aur dikha legend mujhe khud hi me<br/>
                Aur jahape naam hai wahan pe japanah main<br/>
                Saare jaape naam ye wakayi lajawaab main<br/>
                Phoncha kahan se kahan main<br/>
                Meri baatein yahan pe samajh aayna/aaye na<br/>
                Toh apne me jhaakh le (Anh!)<br/>
                Maange nai maafi hum<br/>
                Yahape maante riwaaj nai<br/>
                Aakhri saans tak bahaduri<br/>
                Jaante kaatil ye baat abhi<br/>
                Na parwa kare kahasuni<br/>
                Khaakh daalte ghaas ni<br/>
                Laakh baato pe dhyaan ni<br/>
                Kaat khaate aawaj bhi discussing the best<br/>
                Then gaush comes in her mouth like her lips sucking my dick<br/>
                Wo chahte karu reply me diss fuck a revenge<br/>
                I'm fucking cutting you off like dysfunctional limbs<br/>
                And this one's for the kids who wanted to be the best<br/>
                Man how can a fucking loser be future of DHH (Desi Hip-Hop)?<br/>
                Dikhade tu mujhe choo kar hai shooters with me I bet<br/>
                I make you bleed on the pad you pussy you PMS<br/>
                Emotions they be a mess<br/>
                Man how can I hold these guys<br/>
                They're faking their whole disguise<br/>
                God! Holy Christ<br/>
                Killer crown/kill a clown If they joke that is down right true<br/>
                Coulrophobic but I aint scared of clowns like you<br/>
                Girebaan me tu jhaakh milega tujhe jaan ne ka raaz agar tu dhyan se taraash<br/>
                Sick hai bars likhe aag dil ki baat<br/>
                Leke kaagaz pe jaake nikaal deta aaj<br/>
                So many foes<br/>
                I keep rolling with those fiends<br/>
                We don't keep 'em close now<br/>
                And no we ain't we ain't brodies<br/>
                You're low-key below me<br/>
                Are y'all sipping codeine?<br/>
                You always lean on me<br/>
                Just know we the OG's man<br/>
                <br/>
                [Verse 2: Flowbo]<br/>
                Everybody peeche pagal hai, flow mera qatil hai<br/>
                So much of confidence dekh<br/>
                Bete pehle se main kaabil hai log kehte kya mujhe fucker get out of my face<br/>
                Likha maine kaise raapchik hai<br/>
                Do mahine baad sune toh bui ye bang kare bass<br/>
                Mere saath khade bhai log hai sab saale violent hai rakhte no time for debates<br/>
                Kabhi karenge wo lafde padenge sar pe<br/>
                Thode bhadke the ladke padenge punches<br/>
                Pussy ladke the lagte mere ko virgins<br/>
                Fuck up anybody jaise main &quot;Prince Of Persia&quot; (Yeah)<br/>
                Yeah mere jaise yahan pe kaun?<br/>
                Tere jaise yahan pe boht<br/>
                Versatile hai main ofcourse<br/>
                Certified hum superstars bitch<br/>
                Fuck up anybody jagah pe tere ko shot<br/>
                Pehle sadkon pe kheenchte khast the boht<br/>
                Abhi dekhe mujhe ladke karte baat<br/>
                Peeche pade mere khade wo gharke bahar<br/>
                Sunenge na mera sound tera crowd bole wow<br/>
                Mere bhaav bade bhai mere paav pade baap tera<br/>
                Pade mere peeche dekha maine khaali saamne ka<br/>
                Sabko ni paalne ka, khud ko sambhalne ka<br/>
                Dekho meri energy main jagah pe hi faad dega<br/>
                Dekha maine jealousy ye chalegi nahi bahar nikal<br/>
                Jana gana mana main ton bhartiya naagrik<br/>
                Likhun aise gaane sune baharke prashashan (Bitch!)<br/>
                Bola maine pehle se ye legacy alag hai<br/>
                Meri marzi ka karta main<br/>
                Zara si fikar mujhe kiski nahi fisli zubaan pade fight teri kidney me<br/>
                Lyrically killer kehne waale kidhar<br/>
                Kehte mujhe pehle se tu pohochega na kidhar<br/>
                Everybody get up dekho meri vision<br/>
                Badi meri hype, dekho badi meri image<br/>
                Everybody tired of your tired of your bullshit<br/>
                Pade khaali fight mere bhai tere munh pe<br/>
                Sabhi ko dikhaye ye zabaan pe hai Mumbai<br/>
                Fati teri gaand mere bhai zara sum khaaye<br/>
                <br/>
                [Chorus: Gaush &amp; Flowbo]<br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai? (Kaun hai?)<br/>
                Todenge jagah pe tere ko chodenge kaise new Bombay se (Let's go!)<br/>
                <br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai?<br/>
                Todenge jagah pe tere ko chodenge kaise hum Bombay se<br/>
                <br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai?<br/>
                Todenge jagah pe tere ko chodenge kaise new Bombay se<br/>
                <br/>
                Kisi ki padi na pehle se bola tha chhote tu kaun hai?<br/>
                Todenge jagah pe tere ko chodenge kaise hum Bombay se
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default KaunHai;
